<template>
  <div class="form-list-new-item">
    <SelectSearch
      v-if="autocomplete"
      :placeholder="placeholder"
      :search-function="search"
      :value="inputValue"
      value-label="name"
      @input="onSelect"
    >
      <template #default="{ result }">
        {{ result.description }} {{ result.role }}
      </template>
    </SelectSearch>
    <HTextfield
      v-else
      v-model:value="inputValue"
      :placeholder="placeholder"
      @keyup.enter="onSelect({ code: inputValue })"
    />
  </div>
</template>

<script>
import { CLASSIFICATION_DEMAND_TYPE_MAP } from '@/models/demands'

import { HTextfield, SelectSearch } from '../atoms'

export default {
  name: 'FormListNewItem',
  components: {
    SelectSearch,
    HTextfield
  },
  props: {
    addItem: { type: Function, default: undefined },
    placeholder: { type: String, default: undefined },
    autocomplete: Boolean,
    readonly: Boolean,
    checkRole: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      inputValue: null
    }
  },
  methods: {
    onFocusout(event, select, current) {
      if (!this.$el.contains(event.relatedTarget)) {
        const value = current || { code: this.$refs.input.value }
        select(value)
      }
    },
    searchCid(query, signal) {
      return this.$store.dispatch('pillars/demands/searchDemands', {
        query,
        checkRole: this.checkRole,
        options: {
          signal
        }
      })
    },
    search(query, signal) {
      if (this.autocomplete) {
        return this.searchCid(query, signal)
      }
      return undefined
    },
    parseCid(value) {
      return {
        value: value?.code || value?.name,
        description: value?.description,
        type: CLASSIFICATION_DEMAND_TYPE_MAP[value?.classification],
        name: value?.name
      }
    },
    onSelect(value) {
      if (!value) return
      const item = this.parseCid(value)

      this.addItem(item)
      this.inputValue = ''
    }
  }
}
</script>

<style lang="scss">
.form-list-new-item {
  align-items: center;
  position: relative;
  width: 100%;
}
</style>
